import { readCookie, setCookie } from "./cookies";

const SESSION_KEY = "_gssid";

const setSessionCookie = function (timeoutMins) {
  let sid = readCookie(SESSION_KEY);
  if (sid === null) {
    sid = generateSID();
  }
  setCookie(SESSION_KEY, sid, timeoutMins);
  return sid;
};

const generateSID = function () {
  //Session value should be of the form yyMMddHHmm-{random Base36 string} (the time here is in UTC)
  let d = new Date();
  let yy = "" + (d.getUTCFullYear() % 1000);
  let MM = d.getUTCMonth().toString().padStart(2, "0");
  let dd = d.getUTCDate().toString().padStart(2, "0");
  let hh = d.getUTCHours().toString().padStart(2, "0");
  let mm = d.getUTCMinutes().toString().padStart(2, "0");
  let randomString = Math.random().toString(36).substring(2);
  return yy + MM + dd + hh + mm + "-" + randomString;
};

export { setSessionCookie };
